import { ThemeProvider } from '@change/ds-core-ui/next';

import { EasyBrief } from './components/EasyBrief';
import { TipsAndGuides } from './components/TipsAndGuides';

export const HowToSectionSunrise: React.FC = () => {
	return (
		<ThemeProvider>
			<div className="bg-background-raised" data-testid="homepage-sunrise-how-to-section">
				<EasyBrief />
				<TipsAndGuides />
			</div>
		</ThemeProvider>
	);
};
